import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { EmojiEvent } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from '@src/app/modules/auth';

import { emojiSheetFn } from '../utils';

@Component({
  selector: 'app-emoji-list',
  templateUrl: './emoji-list.component.html',
  styleUrls: ['./emoji-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmojiListComponent {
  private readonly translateService = inject(TranslateService);
  private readonly sessionService = inject(SessionService);

  @Output() emojiClicked = new EventEmitter<string>();

  readonly emojiSheet = emojiSheetFn;

  // TODO: Попробовать подключить через i18n
  readonly emojiListTranslate = {
    search: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.search'),
    emojilist: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.emojilist'),
    notfound: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.notfound'),
    clear: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.clear'),
    categories: {
      search: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesSearch'),
      recent: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesRecent'),
      people: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesPeople'),
      nature: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesNature'),
      foods: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesFoods'),
      activity: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesActivity'),
      places: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesPlaces'),
      objects: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesObjects'),
      symbols: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesSymbols'),
      flags: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesFlags'),
      custom: this.translateService.instant('components.emojiList.constants.emojiMartTranslate.categoriesCustom'),
    },
  };

  protected readonly darkMode = this.sessionService.darkMode;

  onSelectEmoji(event: EmojiEvent) {
    const emojiName = event.emoji.colons;
    this.emojiClicked.emit(emojiName);
  }
}
